!function($, window, document) {
    const $window = $(window), $document = $(document), $body = $("body"), $autoscrolls = $(".js-autoscroll"), $subscribe = $(".js-subscribe"), $popup = $(".popup-project"), $thumbnail = $popup.find(".popup__thumbnail"), DAYS_COUNT_START_DATE = new Date("2 Apr 2009");
    let popupContentRequest = null;
    const popupContentCache = new Map, $popupCache = document.getElementById("popup-cache");
    if ($popupCache) try {
        const data = JSON.parse($popupCache.textContent);
        Object.entries(data).forEach(([hash, html]) => popupContentCache.set(hash, html));
    } catch (err) {}
    const handlePointerDown = e => {
        const $target = $(e.currentTarget);
        $window.width() <= 767 && $target.parents(".js-autoscroll").find(".is-active").removeClass("is-active"), 
        $target.addClass("is-active");
    }, handlePointerUp = e => {
        $(e.currentTarget).removeClass("is-active");
    }, convertCssValue = value => value.endsWith("px") ? Number(value.replace("px", "")) : value.endsWith("rem") ? 10 * Number(value.replace("rem", "")) : Number(value), addTransitionClassesToSiblingSlides = params => {
        const {$siblingSlides: $slides, left: activeLeft, right: activeRight, top: activeTop} = params, windowWidth = $window.outerWidth();
        $slides.each((_, slide) => {
            const $slide = $(slide), {left: left, right: right, top: top} = slide.getBoundingClientRect(), isInViewport = right >= 0 && right <= windowWidth || left >= 0 && left <= windowWidth;
            $slide.toggleClass("in-viewport", isInViewport), isInViewport && ($slide.get(0).style.setProperty("--slide-left", `${left}px`), 
            $slide.get(0).style.setProperty("--slide-right", `${right}px`), $slide.toggleClass("to-left", right < activeLeft), 
            $slide.toggleClass("to-right", left > activeRight), top !== activeTop && ($slide.toggleClass("to-left", left < 0), 
            $slide.toggleClass("to-right", right > windowWidth)));
        });
    }, setActiveSlidePositionCssVariables = (params, skipVars = !1) => {
        const {$slider: $slider, $slide: $slide, ignorePopupAnimation: ignorePopupAnimation} = params, $siblingSlides = $slide.siblings(".embla__slide"), {left: left, right: right, top: top, bottom: bottom, height: height, width: width} = $slide.get(0).getBoundingClientRect();
        if (!$popup.hasClass("animating") || ignorePopupAnimation) {
            if (!skipVars) {
                const cssVariables = {
                    "--top": `${top}px`,
                    "--right": `${right}px`,
                    "--bottom": `${bottom}px`,
                    "--left": `${left}px`,
                    "--width": `${width}px`,
                    "--height": `${height}px`,
                    "--width-unitless": width,
                    "--height-unitless": height
                };
                $slider.add($popup).css(cssVariables);
            }
            $slide.removeClass("in-viewport to-left to-right"), addTransitionClassesToSiblingSlides({
                $siblingSlides: $siblingSlides,
                left: left,
                right: right,
                top: top
            });
        } else $popup.one("custom-event:recalculate", () => {
            const cssVariables = {
                "--top": `${top}px`,
                "--right": `${right}px`,
                "--bottom": `${bottom}px`,
                "--left": `${left}px`,
                "--width": `${width}px`,
                "--height": `${height}px`,
                "--width-unitless": width,
                "--height-unitless": height
            };
            $slider.add($popup).css(cssVariables), $slide.removeClass("in-viewport to-left to-right"), 
            addTransitionClassesToSiblingSlides({
                $siblingSlides: $siblingSlides,
                left: left,
                right: right,
                top: top
            });
        });
    }, handlePopupKeyDown = e => {
        "Escape" === e.key && ($document.off("keydown", handlePopupKeyDown), closePopup());
    }, handlePopupClick = e => {
        $(e.target).closest(".plyr").length || closePopup();
    }, closePopup = () => {
        popupContentRequest && (popupContentRequest.abort(), popupContentRequest = null), 
        $document.off("keydown", handlePopupKeyDown), $popup.off("click", handlePopupClick);
        const $slider = $(".embla"), $slide = $slider.find(".embla__slide.popup-open");
        moveThumbnailToHero(), $popup.addClass("animating"), moveThumbnailToSlide($slide), 
        $(".js-cursor").addClass("is-popup-transitioning"), $popup.find(".popup__inner").html(""), 
        $popup.off("scroll");
        const classesToRemove = [ "popup-open", "in-viewport", "to-left", "to-right" ];
        $("." + classesToRemove.join(", .")).removeClass(classesToRemove), $slider.removeAttr("style").trigger("mouseleave");
        $slider.data("api").plugins().autoScroll.play(), setTimeout(() => {
            $(".js-cursor").removeClass("is-popup-transitioning");
        }, 600);
    }, copySlideImage = $slide => {
        const $thumbnailPicture = $thumbnail.find("picture"), $slidePicture = $slide.find("picture");
        $thumbnailPicture[0].outerHTML !== $slidePicture[0].outerHTML && ($thumbnailPicture.remove(), 
        $slidePicture.clone().appendTo($thumbnail));
    }, setPopupContent = (html, $slide) => {
        const popupContent = html;
        $popup.find(".popup__inner").html(popupContent), openPopup($slide), initPlyr();
    }, initPlyr = () => {
        $(document).find(".plyr").each(function() {
            try {
                let $this = $(this), videoId = $this.attr("id"), autoplay = "true" === $this.attr("data-autoplay"), videoType = $this.data("video-type"), poster = $this.attr("data-poster"), allowFullscreen = "true" === $this.attr("data-allow-fullscreen"), controls = "true" === $this.attr("data-controls") ? [ "play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen" ] : [];
                "true" === $this.attr("data-mute-button") && (controls = [ "mute" ]);
                const videoSettings = {
                    muted: !0,
                    autoplay: autoplay && "embed" === videoType,
                    clickToPlay: "true" === $this.attr("data-click-to-play"),
                    controls: controls,
                    loop: {
                        active: "true" === $this.attr("data-loop")
                    },
                    fullscreen: {
                        enabled: allowFullscreen
                    },
                    storage: {
                        enabled: !1
                    },
                    vimeo: {
                        controls: !1
                    }
                }, player = new Plyr("#" + videoId, videoSettings);
                let classes = $this.attr("class"), styles = $this.attr("style");
                $(player.elements.container).addClass(classes), $(player.elements.container).attr("style", styles), 
                poster && (player.poster = $this.attr("data-poster"));
                let observer = new IntersectionObserver(entries => {
                    entries.map(entry => {
                        entry.isIntersecting && autoplay && player ? player.play() : player.pause();
                    });
                }, {
                    rootMargin: "-15% 0%",
                    threshold: 0
                });
                player.on("ready", () => {
                    player.pause(), observer.observe($this[0]);
                });
            } catch (error) {
                "Plyr is not defined" !== error.message ? console.error("Error initializing Plyr:", error) : console.error("Plyr is not defined.");
            }
        });
    }, moveThumbnailToSlide = $slide => {
        const $thumbnail = $popup.find(".popup__thumbnail");
        if (!$slide.length || !$thumbnail.length) return;
        const {top: top, left: left, width: width, height: height} = $slide.get(0).getBoundingClientRect();
        $thumbnail.css({
            "--top": `${top}px`,
            "--left": `${left}px`,
            "--width": `${width}px`,
            "--height": `${height}px`
        }), $thumbnail.outerHeight();
    }, moveThumbnailToHero = () => {
        const $popupHero = $popup.find(".popup__image--hero"), $thumbnail = $popup.find(".popup__thumbnail");
        if (!$popupHero.length || !$thumbnail.length) return;
        const {top: top, left: left, width: width, height: height} = $popupHero.get(0).getBoundingClientRect();
        $thumbnail.css({
            "--top": `${top}px`,
            "--left": `${left}px`,
            "--width": `${width}px`,
            "--height": `${height}px`
        }), $thumbnail.outerHeight();
    }, openPopup = $trigger => {
        const $slide = $trigger.closest(".embla__slide"), $slider = $slide.closest(".embla"), $hero = $slider.closest(".hero");
        var params;
        $slider.data("api").plugins().autoScroll.stop(), moveThumbnailToSlide($slide), setActiveSlidePositionCssVariables({
            $popup: $popup,
            $slider: $slider,
            $slide: $slide
        }), $popup.addClass("animating"), params = {
            $popup: $popup,
            $body: $body,
            $hero: $hero,
            $slider: $slider,
            $slide: $slide
        }, Object.values(params).map($el => $el.addClass("popup-open")), moveThumbnailToHero(), 
        $slide.get(0), $document.on("keydown", handlePopupKeyDown), $popup.on("click", handlePopupClick), 
        $popup.on("transitionend", e => {
            if (!$(e.target).is($popup)) return;
            const isOpen = $popup.hasClass("popup-open");
            $popup.removeClass("animating"), isOpen || ($popup.trigger("custom-event:recalculate"), 
            $body.get(0).style.setProperty("--popup-scroll", 0)), $popup.scrollTop(0).on("scroll", () => {
                $body.get(0).style.setProperty("--popup-scroll", `${$popup.scrollTop()}px`);
            });
        });
    };
    $document.on("click", ".js-popup-trigger", e => {
        const $trigger = $(e.currentTarget);
        e.preventDefault();
        const slideData = $trigger.data("slide"), cacheKey = slideData._hash;
        if (popupContentCache.has(cacheKey)) return copySlideImage($trigger), void setPopupContent(popupContentCache.get(cacheKey), $trigger);
        popupContentRequest && (popupContentRequest.abort(), popupContentRequest = null), 
        popupContentRequest = $.ajax({
            url: "/wp-json/efr/v1/project_popup",
            method: "POST",
            data: {
                slide: slideData
            },
            success: html => {
                popupContentCache.set(cacheKey, html), copySlideImage($trigger), setPopupContent(html, $trigger);
            }
        });
    });
    const ensureSlidesForAutoscroll = (autoscroll, windowWidth, attempts = 20) => {
        const $container = $(autoscroll).find(".embla__container"), $originalSlides = $container.find(".embla__slide:not(.is-cloned)"), $allSlides = $container.find(".embla__slide"), slidesWidth = $allSlides.length * $allSlides.outerWidth(), slidesCount = $allSlides.length, isMobile = windowWidth <= 767;
        if (0 === attempts) return !1;
        if (!(slidesWidth >= 6 * windowWidth) || isMobile && slidesCount % 2 == 1) {
            const $clones = $originalSlides.clone();
            return $clones.addClass("is-cloned"), $container.append($clones), ensureSlidesForAutoscroll(autoscroll, windowWidth, attempts - 1);
        }
        {
            const $images = $allSlides.find("img");
            return isMobile ? ($images.off("mousedown touchstart", handlePointerDown), $images.on("mousedown touchstart", handlePointerDown)) : ($images.off("mousedown touchstart", handlePointerDown), 
            $images.off("mouseup touchend touchcancel", handlePointerUp), $images.on("mousedown touchstart", handlePointerDown), 
            $images.on("mouseup touchend touchcancel", handlePointerUp)), !0;
        }
    }, initCountUp = countUp => {
        const $countUp = $(countUp), daysDiff = (new Date - DAYS_COUNT_START_DATE) / 864e5, days = Math.floor(daysDiff), prefix = $countUp.data("prefix") ?? "Designing for ", suffix = $countUp.data("suffix") ?? " Days";
        new CountUp(countUp, days, {
            enableScrollSpy: !0,
            startVal: 0,
            useIndianSeparators: !0,
            duration: 1.4,
            prefix: prefix,
            suffix: suffix
        });
    };
    const handleSubscribeInputFocus = e => {
        const $input = $(e.currentTarget), focusPlaceholder = $input.data("focus-placeholder");
        focusPlaceholder && $input.attr("placeholder", focusPlaceholder);
    }, handleSubscribeInputBlur = e => {
        const $input = $(e.currentTarget), blurPlaceholder = $input.data("blur-placeholder");
        blurPlaceholder && $input.attr("placeholder", blurPlaceholder);
    }, applySubscribeInvalidPlaceholder = $subscribe => {
        $subscribe.find('.gfield_error input[type="email"], .gfield_error input[type="text"], input[aria-invalid="true"]').each(function() {
            const $input = $(this);
            $input.attr("placeholder", "Invalid email"), $input.off("input.subscribeInvalid").on("input.subscribeInvalid", function() {
                const blurPlaceholder = $input.attr("data-blur-placeholder") || "";
                $input.attr("placeholder", blurPlaceholder), $input.off("input.subscribeInvalid");
            });
        });
    }, bindSubscribeInputs = $subscribe => {
        const $inputs = $subscribe.find('input[type="email"], input[type="text"]').not("[data-subscribe-bound]");
        $inputs.each(function() {
            const $input = $(this), currentPlaceholder = $input.attr("placeholder") || "";
            !$input.attr("data-blur-placeholder") && currentPlaceholder && "Invalid email" !== currentPlaceholder && $input.attr("data-blur-placeholder", currentPlaceholder), 
            $input.attr("data-focus-placeholder") || $input.attr("data-focus-placeholder", "Enter Email Address"), 
            $input.attr("data-subscribe-bound", "true");
        }), $inputs.on("focus", handleSubscribeInputFocus), $inputs.on("blur", handleSubscribeInputBlur), 
        applySubscribeInvalidPlaceholder($subscribe);
    };
    (autoscrolls => {
        const $autoscrolls = $(autoscrolls), options = {
            loop: !0,
            dragFree: !0
        }, plugins = [ window.EmblaCarouselAutoScroll({
            startDelay: 200,
            speed: 1,
            playOnInit: !0,
            stopOnInteraction: !0,
            stopOnFocusIn: !0,
            stopOnMouseEnter: !1
        }) ], windowWidth = $window.outerWidth();
        $autoscrolls.each((_, autoscroll) => {
            if (ensureSlidesForAutoscroll(autoscroll, windowWidth)) {
                const autoscrollApi = window.EmblaCarousel(autoscroll, options, plugins), $autoscroll = $(autoscroll), $slides = $autoscroll.find(".embla__slide");
                $autoscroll.data("api", autoscrollApi);
                const resumeAutoScroll = () => {
                    !$body.hasClass("popup-open") && autoscrollApi.plugins().autoScroll.play();
                }, stopAutoscroll = () => {
                    $body.hasClass("popup-open") && autoscrollApi.plugins().autoScroll.stop();
                };
                $slides.on("mouseenter", e => {
                    const $slide = $(e.currentTarget);
                    setActiveSlidePositionCssVariables({
                        $slider: $autoscroll,
                        $slide: $slide
                    });
                }), $autoscroll.on("mouseenter", stopAutoscroll), $autoscroll.on("mouseleave", resumeAutoScroll), 
                $autoscroll.on("pointerup", resumeAutoScroll), $autoscroll.on("pointercancel", resumeAutoScroll);
            }
        });
    })($autoscrolls), function initAllCountUps() {
        $(".js-count-up").toArray().map(initCountUp);
    }(), (subscribe => {
        const $subscribe = $(subscribe);
        $subscribe.length && (bindSubscribeInputs($subscribe), $document.on("gform_post_render", () => {
            bindSubscribeInputs($subscribe);
        }));
    })($subscribe), (() => {
        const $cursor = $(".js-cursor"), $body = $("body");
        let mouseX = window.innerWidth / 2, mouseY = window.innerHeight / 2, cursorX = mouseX, cursorY = mouseY;
        let isDragging = !1, lastMouseX = mouseX, lastMouseY = mouseY, isMoving = !1, animationFrameId = null;
        const cursorStates = {
            "is-popup": ".js-popup-trigger, .hero__head a",
            "is-link": "a:not(.js-popup-trigger)",
            "is-input": "input, textarea",
            "is-button": "button",
            "is-image": "img",
            "is-footer": ".footer",
            "is-unscrolled-footer": ".footer:not(.has-scrolled)",
            "is-text": "p, h1, h2, h3, h4, h5, h6"
        }, allCursorClasses = [ ...Object.keys(cursorStates), "is-hovering", "is-dragging", "is-moving", "is-popup-open" ], updateCursorState = $hoveredElement => {
            if (isDragging) return;
            allCursorClasses.forEach(className => {
                "is-dragging" !== className && $cursor.removeClass(className);
            });
            $body.hasClass("popup-open") && $cursor.addClass("is-popup-open"), Object.entries(cursorStates).forEach(([state, selector]) => {
                ($hoveredElement.is(selector) || $hoveredElement.closest(selector).length > 0) && ($cursor.addClass(state), 
                "is-popup" === state && $cursor.addClass("is-hovering"));
            });
        }, forceUpdateCursor = () => {
            const $hoveredElement = $(document.elementFromPoint(mouseX, mouseY));
            updateCursorState($hoveredElement);
        };
        $document.on("click", () => {
            setTimeout(forceUpdateCursor, 10);
        }), $body.on("classChange", function(e, className, isAdded) {
            "popup-open" === className && forceUpdateCursor();
        });
        new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                "class" === mutation.attributeName && forceUpdateCursor();
            });
        }).observe($body[0], {
            attributes: !0
        });
        const checkMovement = () => {
            if (lastMouseX === mouseX && lastMouseY === mouseY) isMoving && (isMoving = !1, 
            $cursor.removeClass("is-moving")); else {
                isMoving || (isMoving = !0, $cursor.addClass("is-moving"));
                const $hoveredElement = $(document.elementFromPoint(mouseX, mouseY));
                updateCursorState($hoveredElement);
            }
            lastMouseX = mouseX, lastMouseY = mouseY, setTimeout(checkMovement, 100);
        };
        checkMovement(), $(document).on("mousedown", () => {
            isDragging = !0, $cursor.addClass("is-dragging");
        }).on("mouseup", () => {
            isDragging = !1, $cursor.removeClass("is-dragging");
            const $hoveredElement = $(document.elementFromPoint(mouseX, mouseY));
            updateCursorState($hoveredElement);
        }), $cursor.css("transform", `translate(-50%, -50%) translate3d(${cursorX}px, ${cursorY}px, 0)`), 
        $cursor.addClass("active"), $(document).mousemove(function(e) {
            mouseX = e.clientX, mouseY = e.clientY, updateCursorState($(e.target));
        });
        const updateCursorPosition = () => {
            cursorX += .75 * (mouseX - cursorX), cursorY += .75 * (mouseY - cursorY), $cursor.css("transform", `translate(-50%, -50%) translate3d(${cursorX}px, ${cursorY}px, 0)`), 
            animationFrameId = requestAnimationFrame(updateCursorPosition);
        };
        animationFrameId = requestAnimationFrame(updateCursorPosition);
    })(), $(".footer").on("click", function() {
        $(this).hasClass("has-scrolled") || $(this)[0].scrollIntoView({
            behavior: "smooth"
        });
    }), $window.on("load resize", () => {
        (() => {
            const $scrollDiv = $("<div>").addClass("scrollbar-measure");
            $body.append($scrollDiv);
            const scrollBarWidth = $scrollDiv.prop("offsetWidth") - $scrollDiv.prop("clientWidth");
            $scrollDiv.remove(), $body.get(0).style.setProperty("--scrollbar-width", `${scrollBarWidth}px`);
        })(), (() => {
            const titleWidth = convertCssValue($popup.css("--popup-title-width")), gap = convertCssValue($popup.css("--popup-gap")), paddingTop = convertCssValue($popup.css("padding-top")), paddingRight = convertCssValue($popup.css("padding-right")), paddingLeft = convertCssValue($popup.css("padding-left")), popupBottomOffset = convertCssValue($popup.css("--popup-bottom-offset")), bodyStyle = (convertCssValue($body.css("--scrollbar-width")), 
            $body.get(0).style);
            bodyStyle.setProperty("--popup-title-width", `${titleWidth}px`), bodyStyle.setProperty("--popup-gap", `${gap}px`), 
            bodyStyle.setProperty("--popup-top-padding", `${paddingTop}px`), bodyStyle.setProperty("--popup-right-padding", `${paddingRight}px`), 
            bodyStyle.setProperty("--popup-left-padding", `${paddingLeft}px`), bodyStyle.setProperty("--popup-bottom-offset", `${popupBottomOffset}px`), 
            $window.outerWidth();
            const windowHeight = $window.outerHeight();
            bodyStyle.setProperty("--popup-gap-unitless", gap), bodyStyle.setProperty("--popup-top-padding-unitless", paddingTop), 
            bodyStyle.setProperty("--popup-bottom-offset-unitless", popupBottomOffset), bodyStyle.setProperty("--window-height-unitless", windowHeight);
        })();
        const $slide = $(".embla__slide.popup-open");
        if ($slide.length > 0) {
            const $slider = $slide.closest(".embla");
            setActiveSlidePositionCssVariables({
                $slider: $slider,
                $slide: $slide,
                ignorePopupAnimation: !0
            });
        }
    }).on("scroll", () => {
        $(".footer").toggleClass("has-scrolled", window.scrollY > 0);
        const $slide = $(".embla__slide:hover");
        if ($slide.length > 0) {
            const $slider = $slide.closest(".embla");
            setActiveSlidePositionCssVariables({
                $slider: $slider,
                $slide: $slide,
                ignorePopupAnimation: !0
            });
        }
    }), $(".footer").toggleClass("has-scrolled", window.scrollY > 0);
}(jQuery, window, document);